module.exports = __webpack_public_path__ + "static/media/xandbox.271c067f.png";